import Vue from "vue";
import md5 from "./md5.min.js";
/*新的调起app页面的库*/
import CallApp from "callapp-lib";

const utils = new (class {
  callNativeApp(target) {
    let callAppLib = new CallApp({
      /*配置URL Scheme所必须的字段*/
      scheme: {
        protocol: "elecnest",
      },
      /*ios通用链接*/
      universal: {
        host: "applink.eda365.com/elecnest/ios",
        pathKey: "target",
      },
      appstore: "https://itunes.apple.com/cn/app/id1437340280?mt=8",
      timeout: 1500,
      fallback: "http://app.eda365.com:8081/download.php",
    });
    callAppLib.open({
      path: target,
      callback: function() {
        if (utils.browserChecker.isAndroid()) {
          location.href = "http://app.eda365.com:8081/download.php";
        }
      },
    });
  }
  communicateToRN(payload) {
    if (payload && payload.type) {
      window.postMessage && window.postMessage(JSON.stringify(payload), "*");
      window.ReactNativeWebView &&
        window.ReactNativeWebView.postMessage(JSON.stringify(payload));
    }
  }
  communicateToNative(methodName, params) {
    if (!methodName) return;
    window.webkit &&
      window.webkit.messageHandlers[methodName].postMessage(params);
    window.androidMessenger &&
      window.androidMessenger[methodName](JSON.stringify(params));
  }

  setUserInfo(uinfo = {}) {
    let storage = window.localStorage;
    if (!storage) {
      utils.showMessage("您当前浏览器版本过低，请升级浏览器以获取更优体验");
      return;
    }
    if (typeof uinfo != "object") {
      throw "参数类型错误";
    }
    storage.setItem("uinfo", JSON.stringify(uinfo));
  }
  getUserInfo() {
    let storage = window.localStorage;
    if (!storage) {
      utils.showMessage("您当前浏览器版本过低，请升级浏览器以获取更优体验");
      return {};
    }
    let uinfo = storage.getItem("uinfo");
    if (!uinfo) {
      return {};
    } else {
      return JSON.parse(uinfo);
    }
  }
  clearUserInfo() {
    let storage = window.localStorage;
    if (!storage) {
      utils.showMessage("您当前浏览器版本过低，请升级浏览器以获取更优体验");
      return;
    }
    storage.removeItem("uinfo");
  }
  showMessage(msg) {
    let options = {
      position: "top-center",
      duration: 1200,
      className: "vue-toasted",
      theme: "outline",
      singleton: true,
    };
    Vue.toasted.show(msg, options);
  }
  reorganizeUrl(url = "", params = {}) {
    if (!url) {
      return "";
    } else {
      let queryObj = Object.assign(utils.getAllQuery(url), params);
      let index = url.indexOf("?"),
        newUrl = "";
      index < 0 ? (newUrl = url + "?") : (newUrl = url.slice(0, index + 1));
      Object.keys(params).forEach((key) => {
        newUrl = newUrl + key + "=" + queryObj[key] + "&";
      });
      return newUrl;
    }
  }
  cs(obj, key) {
    let keys = Object.keys(obj).sort();
    let sign = "";
    keys.forEach((item) => {
      if (obj[item]) {
        sign += obj[item].toString();
      }
    });
    sign += key;
    sign = md5(sign);
    return sign;
  }
  au(videoUrl) {
    if (!videoUrl) {
      return "";
    } else {
      let queryObj = Object.assign(this.getAllQuery(videoUrl), {
        timestamp: (new Date().getTime() / 1000) | 0,
        nonce: `${Math.random()
          .toString()
          .slice(2)}`,
        from: "H5",
      });
      let sign = this.cs(queryObj, "enestedu");
      Object.assign(queryObj, { sign });
      let authorizedVideoUrl = this.reorganizeUrl(videoUrl, queryObj);
      return authorizedVideoUrl;
    }
  }
  cso(obj) {
    let body = {
      timestamp: new Date().getTime() / 1000,
      nonce: `${Math.random()
        .toString()
        .slice(2)}`,
    };
    Object.assign(body, obj);
    Object.assign(body, { sign: utils.cs(body, "edasmscode") });
    return body;
  }
  loginSign(obj) {
    let keys = Object.keys(obj).sort();
    let sign = "";
    keys.forEach((item) => {
      if (obj[item]) {
        sign += String(obj[item]);
      }
    });
    sign += "electnest";
    sign = md5(sign);
    return sign;
  }
  getQuery(name, href) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r;
    if (href) {
      var matchResult = href.match(/(?=.*?)\?.+/g);
      if (!matchResult) return "";
      var search = matchResult[0];
      r = search.substr(1).match(reg);
    }
    if (r != null) return unescape(r[2]);
    return "";
  }
  getAllQuery(url = "") {
    let index = url.indexOf("?");
    if (index < 0) return {};
    let queryStr = url.substr(index + 1);
    if (!queryStr) return {};
    let queryObj = {},
      couples = queryStr.split("&");
    couples.forEach((item) => {
      let temp = item.split("=");
      queryObj[temp[0]] = temp[1];
    });
    return queryObj;
  }
  /*格式化时间戳*/
  formatTime(dateline, separator = "-", showExactTime = true) {
    if (+dateline) {
      var date = null;
      if (dateline.toString().length == 10) {
        date = new Date(dateline * 1000);
      } else {
        date = new Date(+dateline);
      }
      var year = date.getFullYear(),
        month = utils.padZero(date.getMonth() + 1, 2),
        day = utils.padZero(date.getDate(), 2),
        hour = utils.padZero(date.getHours(), 2),
        minute = utils.padZero(date.getMinutes(), 2);
      var timeString = year + separator + month + separator + day;
      showExactTime && (timeString = timeString + " " + hour + ":" + minute);
      return timeString;
    } else {
      return "";
    }
  }
  trimHtmlTag(str = "") {
    return str.replace(/<[^>]+>/g, "");
  }
  /*补前置零*/
  padZero(num, n) {
    var len = num.toString().length;
    while (len < n) {
      num = "0" + num;
      len++;
    }
    return "" + num;
  }
  /*检测输入的邮箱是否合理*/
  checkEmail(text) {
    var reg = /^[\w+-]+(\.[\w+-]+)*@[a-z\d-]+(\.[a-z\d-]+)*\.([a-z]{2,4})$/g;
    return reg.test(text);
  }
  checkPhone(text) {
    var reg = /^1[3-9]\d{9}$/g;
    return reg.test(text);
  }
  /*检测输入的密码是否合理*/
  checkPassword(text) {
    /*大于6位字符  \u4e00-\u9fa5汉字就算了*/
    var reg = /^[a-zA-Z0-9!@#$%^&*.]{6,}$/g;
    return reg.test(text);
  }
  checkStrongPassword(text) {
    /*大小写混合数字6-18位*/
    var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])[a-zA-Z0-9!@#$%^&*.]{6,18}$/g;
    return reg.test(text);
  }
  checkEmpty(text) {
    return !text;
  }
  checkTrue(value) {
    return !!value;
  }

  checkHideArea(t) {
    var e = t || "";
    return (e = e.replace(
      /\[hide\][^[\]]*\[\/hide\]/gi,
      '<div class="hideTagArea"><span class="hideTagText">隐藏内容需回复才能查看 已回复？<a class="refreshButton" onclick="init()">刷新</a></span></div>'
    ));
  }
  checkAttachment(t) {
    var e = t || "",
      n = [],
      i = [],
      a = e.match(/\[attach\]((?!\[attach).)+(?=\[\/attach])/g);
    if (a)
      for (var r in a) {
        var o = a[r].replace(/\[attach\]/g, "").split("|");
        (n[r] = o[0]), (i[r] = o[1]);
        var s =
          '<div class="attachArea"><span class="attachText"></span><a class="attachLink" onclick="downloadAction(' +
          o[0] +
          ",'" +
          o[1] +
          "')\">" +
          o[1] +
          "</a></div>";
        e = e.replace(/\[attach\]((?!\[attach).)+\[\/attach]/, s);
      }
    return e;
  }
  checkTopicLink(text) {
    let string = text || "";
    /*let links = string.match(/<a[^>]+src="([^"]+)"[^>]*>([^>]+)<\/a>/g)*/
    let env = process.env.NODE_ENV;
    let isEmptyBase = process.env.VUE_APP_EMPTY_BASE == "emptybase";
    let base = "";
    if (!isEmptyBase) {
      env == "development" ? (base = "/m/devtest") : (base = "/pages/m");
    }
    return string.replace(
      /<a[^>]+href="([^"]+)"[^>]*>([^>]+)<\/a>/g,
      `<div data-href="$1" class="urlMod">
      	<div class="urlText">
      	  <span class="urlTitle">$2</span>
      	  <span class="urlUrl">
      	    <img src="${base}/static/img/urlNo2.png" alt="">
      	    $1
      	  </span>
      	</div>
      	<div class="urlIcon">
      	  <img src="${base}/static/img/urlNo1.png" alt="" >
      	</div>
    	</div>`
    );
  }
  nativeBack() {
    window.postMessage(
      JSON.stringify({
        type: "navback",
      }),
      "*"
    ),
      window.ReactNativeWebView &&
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: "navback",
          })
        ),
      window.webkit && window.webkit.messageHandlers.navback.postMessage({});
  }
  awaitPostMessage() {
    var t = !!window.originalPostMessage,
      e = [],
      n = function(t) {
        e.length > 100 && e.shift(), e.push(t);
      };
    if (!t) {
      var i = window.postMessage;
      Object.defineProperty(window, "postMessage", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return n;
        },
        set: function(e) {
          (n = e), (t = !0), setTimeout(a, 0);
        },
      }),
        (window.postMessage.toString = function() {
          return String(i);
        });
    }
    function a() {
      for (; e.length > 0; ) window.postMessage(e.shift());
    }
  }

  browserChecker = {
    isAndroid: function() {
      return !!navigator.userAgent.match(/Android/i);
    },
    isMobileQQ: function() {
      var t = navigator.userAgent;
      return (
        /(iPad|iPhone|iPod).*? (IPad)?QQ\/([\d.]+)/.test(t) ||
        /\bV1_AND_SQI?_([\d.]+)(.*? QQ\/([\d.]+))?/.test(t)
      );
    },
    isIOS: function() {
      return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    isIphoneX: function() {
      return (
        /iphone/gi.test(navigator.userAgent) &&
        screen.height == 812 &&
        screen.width == 375
      );
    },
    isWx: function() {
      return !!navigator.userAgent.match(/micromessenger/i);
    },
    isChrome: function() {
      return !(
        !navigator.userAgent.match(/Chrome\/([\d.]+)/) &&
        !navigator.userAgent.match(/CriOS\/([\d.]+)/)
      );
    },
    isBaidu: function() {
      return !!navigator.userAgent.match(/baidubrowser/i);
    },
    isUC: function() {
      return !!navigator.userAgent.match(/UCBrowser/i);
    },
    isSafari: function() {
      return !!navigator.userAgent.match(/safari/i);
    },
    isQQBrowser: function() {
      return !!navigator.userAgent.match(/MQQBrowser/i);
    },
    isWeibo: function() {
      return !!navigator.userAgent.match(/weibo/i);
    },
    isAlipay: function() {
      return !!navigator.userAgent.match(/Alipay/i);
    },
    isElecnest: function() {
      return !!navigator.userAgent.match("app_elecnest");
    },
  };

  navToMap = (addressInfo, type) => {
    const systemSetting = {
      // 腾讯地图Key
      txKey: "YQPBZ-XOAKZ-I2SXF-7477G-WEP73-FTFVO",
      // 跳转App公共地址
      mapUrlConfig: {
        baidu: "baidumap://map/walknavi",
        gaode: {
          ios: "iosamap://navi",
          android: "androidamap://viewMap",
        },
        tengxun: "qqmap://map/marker",
      },
    };
    const { lat, lng, name, address } = addressInfo;
    const addressStr = address || "";
    let url;
    const u = navigator.userAgent;
    //判断ios
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    //判断Android
    const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    if (!isIOS && !isAndroid) {
      //   return showToast("此设备暂不支持");
      return;
    }
    if (type === 1) {
      // 百度
      url = `${systemSetting.mapUrlConfig.baidu}?destination=${lat},${lng}&title=${name}&content=${addressStr}&output=html&coord_type=gcj02&src=test`;
    } else if (type === 3) {
      // 腾讯
      url = `${systemSetting.mapUrlConfig.tengxun}?marker=coord:${lat},${lng};title:${name};addr:${addressStr}&referer=${systemSetting.txKey}`;
    } else {
      // 高德
      let params = `?sourceApplication=mingyue&poiname=${name}&lat=${lat}&lon=${lng}&dev=0&t=2`;
      const { android, ios } = systemSetting.mapUrlConfig.gaode;
      url = (isAndroid ? android : ios) + params;
    }
    if (url) {
      window.location.href = url;
    }
  };
})();

export default utils;
